import React from 'react'
import { createRoot } from 'react-dom/client'
import './polyfills.js' // React 18 compatibility polyfills
import './assets/js/app.scss' // Import main SASS styles
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'
import App from './assets/js/app-client.jsx'

// Basic error handling for critical issues
window.addEventListener('error', (e) => {
  // Handle specific error types that need to be suppressed
  if (e.error && e.error.message) {
    if (e.error.message.includes('document.write')) {
      e.preventDefault(); // Prevent the error from propagating
      return;
    }
  }
})

window.addEventListener('unhandledrejection', (e) => {
  // Handle Bootstrap loading failures gracefully
  if (e.reason && e.reason.message && e.reason.message.includes('bootstrap')) {
    e.preventDefault(); // Prevent unhandled rejection
  }
})

try {
  const root = createRoot(document.getElementById('root'))
  
  root.render(<App />)
  
  // Hide the initial loading spinner once React has rendered
  const initialLoading = document.getElementById('initial-loading')
  if (initialLoading) {
    initialLoading.style.display = 'none'
  }
} catch (error) {
  console.error('Critical application error:', error)
  
  // Try to provide a fallback UI
  const root = document.getElementById('root')
  if (root) {
    root.innerHTML = `
      <div style="padding: 20px; color: red; font-family: Arial, sans-serif;">
        <h2>Application Error</h2>
        <p>Failed to load the application. Please refresh the page.</p>
      </div>
    `
  }
}
